import React from 'react'
import ReactDOM from 'react-dom'
import SpeedChart from '../../ReactComponents/Components/SpeedChart'
import moment from 'moment'
import { mapsHereDotComApiKey as MAPS_HERE_API_KEY } from '../../../environments/common'
import { USER_ROLES } from '../../constants/userDetails'

const SemVerGte = require('semver/functions/gte')
const deviceEventSettings = window.filterEnvironmentDeviceSettings(
  require('cloud-utils/config/events/default.json').deviceEventSettings
)
const { DEVICES_EVENTS } = require('../../constants/devices/devicesEvents')
const { DEVICE_STATUS } = require('../../constants/devices/deviceStatuses')

angular.module('surfsightApp.controllers').controller('mapCtrl', [
  '$scope',
  '$compile',
  '$rootScope',
  '$state',
  '$stateParams',
  '$timeout',
  '$interval',
  '$location',
  '$window',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdSidenav',
  '$mdMedia',
  'edgeFactoryV2',
  'edgeGroupFactory',
  'broadcastViewFactory',
  'leafletData',
  'leafletBoundsHelpers',
  'nominatimLookUp',
  'geofenceFactory',
  'SystemConstants',
  'UnitSystem',
  '$q',
  function (
    $scope,
    $compile,
    $rootScope,
    $state,
    $stateParams,
    $timeout,
    $interval,
    $location,
    $window,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdSidenav,
    $mdMedia,
    edgeFactoryV2,
    edgeGroupFactory,
    broadcastViewFactory,
    leafletData,
    leafletBoundsHelpers,
    nominatimLookUp,
    geofenceFactory,
    SystemConstants,
    UnitSystem,
    $q
  ) {
    const originalMapCenter = {
      lat: 34.9818539,
      lng: -23.1277232,
      zoom: 3
    }
    const $translate = $filter('translate')
    $scope.paths = []
    $scope.mapFirstZoom = true
    $scope.dragZoomStatus = false
    $scope.$on('mapFirstZoom', function () {
      $scope.mapFirstZoom = true
      $scope.dragZoomStatus = false
    })
    const allEdges = []
    $scope.edges = allEdges
    $scope.tripsPaths = []
    $scope.event_markers = []
    $scope.currentState = $state.current.name
    $scope.geofenceList = []
    let locationUpdateStatus = false
    let tripsMarkers = []
    let eventMarkers = []
    $scope.allMarkers = []
    let markerFromPostedSpeedGraph = null
    let drawEventAdded = false
    $scope.markerPopupOpen = true
    $scope.disablePopupCloseOnDrag = false
    const missingLastPositionToastShown = {}

    const showMissingLastPositionToastOnce = edgeImei => {
      if (missingLastPositionToastShown[edgeImei]) return
      missingLastPositionToastShown[edgeImei] = true
      $scope.showMessageToast(
        $translate('theLastPositionOfTheDashcamIsNotAvailable')
      )
    }

    const resetMissingLastPositionToast = edgeImei => {
      missingLastPositionToastShown[edgeImei] = false
    }

    const getMapLayers = layerType => {
      const defaultLayer = layerType || 'hereMapsLayerBasePedestrianDay'
      const availableBaseLayers = {
        hereMapsLayerAerialHybridDay: {
          name: $translate('satellite'),
          type: 'xyz',
          url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/{format}?size={size}&style={style}&lang={language}&apiKey={apiKey}`,
          layerOptions: {
            attribution: '',
            app_id: 'N/A',
            app_code: 'N/A',
            maxZoom: $scope.data.whitelabel.whiteLabelMapType ? 15 : 20,
            format: 'png8',
            size: '256',
            style: 'explore.satellite.day',
            language: 'en',
            apiKey: `${MAPS_HERE_API_KEY}`
          }
        },
        hereMapsLayerBasePedestrianDay: {
          name: $translate('mapView'),
          type: 'xyz',
          url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/{format}?size={size}&style={style}&lang={language}&apiKey={apiKey}`,
          layerOptions: {
            attribution: '',
            app_id: 'N/A',
            app_code: 'N/A',
            maxZoom: $scope.data.whitelabel.whiteLabelMapType ? 15 : 20,
            format: 'png8',
            size: '256',
            style: 'explore.day',
            language: 'en',
            apiKey: `${MAPS_HERE_API_KEY}`
          }
        },
        hereMapsLayerTrafficSatelliteDay: {
          name: $translate('traffic'),
          type: 'xyz',
          url: `https://maps.hereapi.com/v3/base/mc/{z}/{x}/{y}/{format}?size={size}&style={style}&lang={language}&apiKey={apiKey}&features=vehicle_restrictions:active_and_inactive,public_transit:all_systems,congestion_zones:all,low_speed_zones:all`,
          layerOptions: {
            attribution: '',
            app_id: 'N/A',
            app_code: 'N/A',
            maxZoom: $scope.data.whitelabel.whiteLabelMapType ? 15 : 20,
            format: 'png8',
            size: '256',
            style: 'topo.day',
            language: 'en',
            apiKey: `${MAPS_HERE_API_KEY}`
          }
        }
      }
      return {
        [defaultLayer]: availableBaseLayers[defaultLayer],
        ...(() => {
          delete availableBaseLayers[defaultLayer]
          return availableBaseLayers
        })()
      }
    }
    if (!$localStorage.userDetails.userSettings) {
      $localStorage.userDetails.userSettings = {
        mapLayerId: ''
      }
    }
    $scope.map_layers = {
      baselayers: getMapLayers(
        $localStorage.userDetails.userSettings.mapLayerId
      )
    }
    const containerElement = document.getElementById('graph-container')

    const centerOnLineClick = point => {
      leafletData.getMap().then(function (map) {
        const lat = point.activePayload[0].payload.position.lat
        const lng = point.activePayload[0].payload.position.lon
        map.setView([lat, lng], 14)
        if (markerFromPostedSpeedGraph) {
          markerFromPostedSpeedGraph.setLatLng(new L.LatLng(lat, lng))
        } else {
          const iconObject = L.icon({
            iconUrl: './images/marker-icon.png',
            shadowUrl: './images/marker-shadow.png',
            shadowSize: [50, 64],
            shadowAnchor: [4, 62],
            iconAnchor: [12, 40]
          })
          markerFromPostedSpeedGraph = L.marker([lat, lng], {
            icon: iconObject
          })
            .addTo(map)
            .on('click', function (e) {
              map.removeLayer(markerFromPostedSpeedGraph)
              markerFromPostedSpeedGraph = null
            })
        }
      })
    }
    const renderSpeedChart = data => {
      const unitsString = UnitSystem.current == 'imperial' ? 'MP/h' : 'Km/h'
      ReactDOM.render(
        <SpeedChart
          cb={centerOnLineClick}
          data={data}
          unitsString={unitsString}
        />,
        containerElement
      )
    }

    const destroySpeedChart = element => {
      ReactDOM.unmountComponentAtNode(element)
    }
    $scope.onSpeedChartClicked = () => {
      closeMapMediaPlayers()
    }
    const closeMapMediaPlayers = () => {
      $rootScope.$broadcast('closeMapMediaPlayers', {})
    }

    $scope.mapCenter = angular.copy(originalMapCenter)
    $scope.UnitSystem = UnitSystem
    if ($localStorage.measurementUnits == 1) {
      SystemConstants.unit = 1
    } else {
      SystemConstants.unit = 0
    }
    $scope.showGeofencePaths = function (edge = false) {
      const geofencePaths = []
      const fenceLatLngsArray = []
      let currentFence = {}
      $scope.geofenceList = geofenceFactory.list
      geofenceFactory.list.forEach(function (e, i) {
        currentFence = e
        geofenceFactory.list[i].opened = false
        geofencePaths.push({
          message:
            "<p  style='margin: 10px 0;font-size: 14px;'>Fence Name: " +
            e.name +
            '</p><!--p>Dashcam Name: ' +
            edge.name +
            '</p-->',
          weight: 2,
          color: 'red',
          fillColor: 'red',
          latlngs: {
            lat: e.lat,
            lng: e.lon,
            draggable: false
          },
          radius: e.radius,
          type: 'circle',
          fence_id: e.id,
          fence_name: e.name
        })
        fenceLatLngsArray.push({ lat: e.lat, lng: e.lon })
      })

      $scope.paths = geofencePaths
      if (currentFence.lat && currentFence.lon) {
        $scope.mapCenter = {
          lat: currentFence.lat,
          lng: currentFence.lon,
          zoom: 13
        }
      }
      if ($scope.paths.length > 1) {
        leafletData.getMap().then(function (map) {
          map.fitBounds(fenceLatLngsArray)
        })
      }
    }
    $scope.addGeofence = function () {
      if ($localStorage.userDetails.permission_role != 'user') {
        const edge_id = $scope.edge_id
        if ($mdMedia('sm') || $mdMedia('xs')) {
          $scope.closeSideNav('geofence-list')
        }
        $scope.geofenceLength = geofenceFactory.list.length
        leafletData.getMap().then(function (map) {
          if (!drawEventAdded) {
            map.on('draw:created', function (e) {
              if (geofenceFactory.list.length < 99) {
                const type = e.layerType
                const layer = e.layer
                const geoJSON = layer.toGeoJSON()
                const radius = layer.getRadius()
                if (radius <= 49) {
                  $scope.showMessageToast(
                    $translate('GeofenceRadiusShouldBeAtLeast50Meters')
                  )
                  leafletData.getMap().then(map => map.removeLayer(layer))
                  $scope.$emit('clearGeofence', {})
                  return false
                }
                geoJSON.properties.radius = radius
                const geoJSON_data = geoJSON
                layer.addTo(map)
                $scope.showAddGeofenceModal(geoJSON_data, layer, $scope.edge_id)
              } else {
                $scope.showMessageToast(
                  $translate('itIsNotPossibleToAddFenceThereIsALimitOf99')
                )
              }
            })
            drawEventAdded = true
          }
          const circleDrawer = new L.Draw.Circle(map)
          circleDrawer.enable()
        })
      } else {
        $scope.showMessageToast($translate('accessDenied'))
      }
    }
    const drawnItems = new L.FeatureGroup()
    const options = {
      editable: true,
      edit: {
        featureGroup: drawnItems
      },
      draw: {
        polygon: {
          shapeOptions: {
            color: '#f44336'
          }
        },
        circle: {
          shapeOptions: {
            stroke: true,
            dashArray: '5,5',
            weight: 1,
            color: '#f44336',
            opacity: 0.5,
            fill: false,
            fillColor: null, // same as color by default
            fillOpacity: 0.2,
            clickable: true
          }
        }
      },
      showRadius: true
    }
    const drawControl = new L.Control.Draw(options)
    $scope.controls = {
      custom: [
        new L.Control.Search({
          url: 'https://nominatim.openstreetmap.org/search?format=json&q={s}',
          jsonpParam: 'json_callback',
          propertyName: 'display_name',
          propertyLoc: ['lat', 'lon'],
          marker: false,
          autoCollapse: true,
          autoType: false,
          minLength: 2,
          zoom: 13
        }).on('search:locationfound', () => {
          leafletData.getMap().then(map => {
            map.setZoom(14)
          })
        }),
        drawControl
      ]
    }

    const mapControl = new L.Control()
    mapControl.setPosition('topleft')
    mapControl.onAdd = function () {
      const className = 'leaflet-custom-control'

      const container = L.DomUtil.create(
        'div',
        className + ' leaflet-bar fenceIcon'
      )

      angular
        .element(container)
        .append('<i class="material-icons">location_on</i>')

      L.DomEvent.addListener(container, 'click', showGeofenceView)
      // Search a lot for this click also.
      return container
    }
    const geofenceControl = new L.Control()
    geofenceControl.setPosition('topleft')
    geofenceControl.onAdd = function () {
      const className = 'leaflet-custom-control'

      const container = L.DomUtil.create(
        'div',
        className + ' leaflet-bar mapIcon'
      )
      angular
        .element(container)
        .append('<i class="material-icons">my_location</i>')
      L.DomEvent.addListener(container, 'click', () => {
        const edgeId = $state.params.edge_id
        if ($state.current.name === 'home.common.maps.geofence') {
          toggleElement('mapIcon', 'flex')
          toggleElement('fenceIcon', 'flex')
          $state.go('home.common.maps.edgeTrips', { edge_id: edgeId })
          mapEvent(edgeId)
        } else {
          $scope.mapLoadingStatus = true
          $scope.mapFirstZoom = true
          $scope.allMarkers = []
          $scope.paths = []
          $scope.decorations = {}
          locationUpdateStatus = true
        }
        if (edgeId) {
          manageDeviceLastLocation(edgeId)
        }
      })
      return container
    }
    $scope.controls.custom.push(mapControl)
    $scope.controls.custom.push(geofenceControl)

    const locationUpdateStatusInterval = $interval(() => {
      locationUpdateStatus && updateMarkers()
      if (openedEdgeMarkerId) {
        const edge = allEdges.find(e => e.imei === openedEdgeMarkerId)
        if (edge && edge.status === DEVICE_STATUS.ONLINE) {
          updateActiveCameras(edge.imei)
        }
      }
    }, 15000)

    const loadRpcOrganizationOverview = () => {
      $scope.mapLoadingStatus = allEdgesFirstTime

      const requestJson = {
        method: 'GET',
        url: `${V2_BASEURL}/organizations/${$rootScope.currentUserOrganization.id}/devices?located`,
        headers: {
          source: 'x-surfsight-internal'
        }
      }
      $http(requestJson).then(({ data }) => {
        allEdges.splice(0, allEdges.length)
        data.data.forEach(device => {
          if (!device) return
          device.lastSeenOnline = device.lastSeenOnline
            ? new Date(device.lastSeenOnline).getTime()
            : new Date().getTime()
          allEdges.push(device)
        })
        $scope.allMarkers = allEdges.map(getDeviceMarker)
        if (allEdgesFirstTime) {
          allEdgesFirstTime = false
          const latLonArray = allEdges.map(edge => ({
            lat: edge.lat,
            lng: edge.lon
          }))
          if (!latLonArray.length) return
          leafletData.getMap().then(map => {
            $timeout(() => {
              if (map.getPanes().mapPane) {
                map.fitBounds(latLonArray)
              }
              $scope.mapLoadingStatus = false
            }, 1000)
          })
        }
      })
    }
    const manageDeviceLastLocation = edgeImei => {
      const edge = edgeFactoryV2.list.find(e => e.imei === edgeImei)
      if (edge) {
        edge.serialNumber = edge.imei
        const existingDeviceIndex = allEdges.findIndex(
          e => e.imei === edge.imei
        )
        existingDeviceIndex === -1
          ? allEdges.push(edge)
          : (allEdges[existingDeviceIndex].cameras = edge.cameras)
        updateDeviceLastLocation(edgeImei)
      } else {
        updateDeviceCameras(edgeImei, true)
      }
    }
    let updateDeviceLastLocationCanceller
    const updateDeviceLastLocation = edgeImei => {
      const edge = edgeFactoryV2.list.find(e => e.imei === edgeImei)
      let locationFound = false
      if (
        updateDeviceLastLocationCanceller &&
        updateDeviceLastLocationCanceller.promise.$$state.status === 0
      ) {
        updateDeviceLastLocationCanceller.resolve()
      }
      updateDeviceLastLocationCanceller = $q.defer()

      edgeFactoryV2
        .getSingleDevice($rootScope.currentUserOrganization.id, edge.imei, {
          timeout: updateDeviceLastLocationCanceller.promise
        })
        .then(response => {
          let device = allEdges.find(e => e.imei === edge.imei)

          if (device) {
            device = {
              ...device,
              ...response
            }

            if (device.lat && device.lon) {
              locationFound = true
              resetMissingLastPositionToast(edgeImei)
              $scope.allMarkers = [getDeviceMarker(device, true)]
              if ($scope.markerPopupOpen) {
                $scope.disablePopupCloseOnDrag = true
                leafletData.getMap().then(map => {
                  const zoom = $scope.mapFirstZoom ? 18 : map._zoom
                  if (!map.getBounds().contains([device.lat, device.lon])) {
                    $scope.dragZoomStatus = false
                  }
                  if (!$scope.dragZoomStatus || $scope.mapFirstZoom) {
                    $timeout(() => {
                      map.setView([device.lat, device.lon], zoom, {
                        animate: false
                      })
                    })
                  }
                  $scope.disablePopupCloseOnDrag = false
                  $scope.mapFirstZoom = false
                })
              }
            } else {
              $scope.allMarkers = []
            }
          }
        })
        .catch(error => {
          if (error.xhrStatus === 'abort') return
          handleServerError(error)
          if (!locationFound) {
            showMissingLastPositionToastOnce(edgeImei)
          }
        })
        .finally(() => {
          $scope.mapLoadingStatus = false
        })
    }

    const updateDeviceCameras = (edgeImei, updateLocation = true) => {
      edgeFactoryV2
        .getSingleDevice($rootScope.currentUserOrganization.id, edgeImei)
        .then(edge => {
          edge.serialNumber = edge.imei
          edgeFactoryV2.addOrUpdateItem(edge)
          const existingDeviceIndex = allEdges.findIndex(
            e => e.imei === edge.imei
          )
          existingDeviceIndex === -1
            ? allEdges.push(edge)
            : (allEdges[existingDeviceIndex].cameras = edge.cameras)
          updateLocation && updateDeviceLastLocation(edgeImei)
        })
        .catch(handleServerError)
    }
    const updateMarkers = () => {
      destroySpeedChart(containerElement)
      $state.params.edge_id
        ? manageDeviceLastLocation($state.params.edge_id)
        : loadRpcOrganizationOverview()
    }
    updateMarkers()
    let allEdgesFirstTime = true

    const updateActiveCameras = imei => {
      edgeFactoryV2
        .getActiveCameras(imei)
        .then(({ data }) => {
          if (data.data) {
            const cameraIds = data.data.map(camera => camera.cameraId)
            const edge = allEdges.find(device => device.imei === imei)
            if (edge) {
              edge.onlineCameraIds = cameraIds
            }
          }
        })
        .catch(error => {
          handleServerError(error)
        })
    }

    const handleServerError = response => {
      $scope.$emit('handleServerError', response)
    }
    const getNearestLocationDetailsOnPolylineSegments = (
      map,
      latlngs,
      point
    ) => {
      const lineSegments = latlngs.reduce(
        (_lineSegments, latlng, index) => [
          ..._lineSegments,
          ...(index ? [new L.Polyline([latlng, latlngs[index - 1]])] : [])
        ],
        []
      )
      const closestLineSegment = L.GeometryUtil.closestLayer(
        map,
        lineSegments,
        point
      )
      const closesPointOnSegment = L.GeometryUtil.closest(
        map,
        closestLineSegment.layer,
        point,
        true
      )
      const closestPointIndex = latlngs.findIndex(
        p =>
          p.lat === closesPointOnSegment.lat &&
          p.lon === closesPointOnSegment.lon
      )
      return {
        index: closestPointIndex,
        location: latlngs[closestPointIndex]
      }
    }
    const showGeofenceView = () => {
      $scope.allMarkers = []
      $scope.paths = []
      $scope.decorations = {}
      toggleElement('fenceIcon', 'none')
      $state.go('home.common.maps.geofence', { edge_id: $state.params.edge_id })
    }
    const mapEvent = edgeId => {
      toggleElement('fenceIcon', 'flex')
      toggleElement('mapIcon', 'flex')
      $scope.paths = []
      $scope.edge = edgeFactoryV2.findItemByImei(edgeId).item
      $state.go('home.common.maps.edgeTrips', { edge_id: edgeId })
      updateCurrentDeviceSemanticVersion()
      if ($mdMedia('sm') || $mdMedia('xs')) {
        if ($state.current.name === 'home.common.maps.geofence') {
          $scope.closeSideNav('geofence-list')
        }
        if ($state.current.name === 'home.common.maps.edgeTrips') {
          $scope.closeSideNav('trips-list')
        } else {
          $scope.closeSideNav('edge-list')
          $scope.closeSideNav('map-multiple-braodcast-videos')
          $scope.closeSideNav('map-media-players')
          $scope.openSideNav('edges-map-sidenav')
        }
      }
    }
    const updateCurrentDeviceSemanticVersion = async () => {
      if (!$scope.edge.semanticVersion) {
        const imei = $scope.edge.imei || $scope.edge.serialNumber
        const e = await edgeFactoryV2
          .getDeviceTelemetry(imei)
          .catch(response => {
            if (response.status === 417) {
              const { item } = edgeFactoryV2.findItemByImei(imei)
              return item
            } else {
              handleServerError(response)
              $scope.showMessageToast(response.data.message)
            }
          })
        $scope.edge.semanticVersion =
          e && e.firmwareVersion ? e.firmwareVersion : null
      }
      const canPlaySelectedQualityRecording = SemVerGte(
        $scope.edge.semanticVersion,
        window.CAN_PLAY_SELECTED_QUALITY_RECORDING_STREAM_VERSION
      )
      $scope.edge.canPlaySelectedQualityRecording = canPlaySelectedQualityRecording
      $scope.setRecordingStreamQuality(
        $scope.edge.canPlaySelectedQualityRecording
          ? window.LOW_QUALITY_RECORDING_STREAM
          : window.HIGH_QUALITY_RECORDING_STREAM
      )
    }
    $scope.setRecordingStreamQuality = recordingStreamQuality => {
      $scope.selectedRecordingStreamQuality = recordingStreamQuality
    }
    $scope.$on('mapEvent', function (e, data) {
      mapEvent(data.edge_id)
    })
    $scope.$on('mapSidenavOpen', function (e, data) {
      const edge = allEdges.find(e => e.imei === $state.params.edge_id)
      leafletData.getMap().then(function (map) {
        $timeout(() => {
          map.invalidateSize()
        }, 300)
      })
      if (edge) {
        $scope.mapCenter = {
          lat: edge.latitude,
          lng: edge.longitude
        }
      }
    })
    $scope.$on('currentState', function (e, data) {
      locationUpdateStatus = false
      if (data.stateName === 'home.common.maps.edgeTrips') {
        locationUpdateStatus = true
        $timeout(function () {
          toggleElement('fenceIcon', 'flex')
          toggleElement('mapIcon', 'flex')
        }, 100)
      } else if (data.stateName === 'home.common.maps.geofence') {
        $timeout(function () {
          toggleElement('fenceIcon', 'none')
          toggleElement('mapIcon', 'flex')
        }, 100)
      } else if (data.stateName === 'home.common.maps.view') {
        $scope.decorations = []
        $scope.paths = []
        $scope.allMarkers = []
        allEdgesFirstTime = true
        locationUpdateStatus = true
        updateMarkers()
        $timeout(function () {
          toggleElement('fenceIcon', 'none')
          toggleElement('mapIcon', 'none')
        }, 100)
      }
    })
    $scope.$on('tripsDataEmit', function (e, data) {
      $scope.paths = []
      $scope.tripsPaths = data.data.tripsData
      tripsMarkers = []
      const edgeId = data.data.edge_id
      const tripSearch = data.data.tripSearch
      const edge = edgeFactoryV2.findItemByImei(edgeId).item
      if (!edge) return
      $scope.loadEdgeEvents(edge, tripSearch.date.start, tripSearch.date.end)
    })
    $scope.$on('selectedTripsEmit', async (e, { data }) => {
      try {
        const trip = data.tripsData
        const edgeId = data.edge_id
        locationUpdateStatus = false
        $scope.mapLoadingStatus = true
        const map = await leafletData.getMap()
        map.closePopup()
        $scope.$on('$destroy', destroySpeedChart(containerElement))
        $scope.$on('closeAllBroadcasts', () => {
          destroySpeedChart(containerElement)
        })
        const gpsPointsResponse = await $http({
          method: 'GET',
          url: V2_BASEURL + '/devices/' + edgeId + '/gps',
          params: {
            start: moment.unix(trip.start.time).format(),
            end: moment.unix(trip.end.time).format()
          }
        })
        $scope.paths = []
        $scope.decorations = {}
        $scope.allMarkers = []
        let selectedTripEvents = []
        tripsMarkers = []
        if (markerFromPostedSpeedGraph) {
          map.removeLayer(markerFromPostedSpeedGraph)
          markerFromPostedSpeedGraph = null
        }
        let positions
        const rawGpsPoints = gpsPointsResponse.data.data
        const unitsConvertMultiplier =
          UnitSystem.current !== 'imperial' ? 3.6 : 2.23694
        const _rawGpsPoints = JSON.parse(JSON.stringify(rawGpsPoints))
        const chartData = _rawGpsPoints
          .sort((a, b) => a.time - b.time)
          .map(e => {
            let obj = {
              position: e,
              speed:
                (e.speed && (e.speed * unitsConvertMultiplier).toFixed()) || 0,
              postedSpeed:
                (e.postedSpeed &&
                  (e.postedSpeed * unitsConvertMultiplier).toFixed()) ||
                0,
              postedSpeedTrailer:
                (e.postedSpeedTrailer &&
                  (e.postedSpeedTrailer * unitsConvertMultiplier).toFixed()) ||
                0,
              postedSpeedHgv:
                (e.postedSpeedHgv &&
                  (e.postedSpeedHgv * unitsConvertMultiplier).toFixed()) ||
                0,
              time: moment(e.time * 1000).format('HH:mm')
            }
            return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v))
          })
        renderSpeedChart(chartData)
        positions = rawGpsPoints
          .map(p => [p.lon, p.lat])
          .map(p => p.reverse())
          .reverse()
        const {
          0: tripStartPoint,
          [positions.length - 1]: tripEndPoint
        } = positions
        tripsMarkers.push({
          edge_id: edgeId,
          marker_type: 'trips_marker',
          lat: tripStartPoint[0],
          lng: tripStartPoint[1],
          icon: {
            iconUrl: require('../../images/marker-start.png'),
            iconSize: [20, 20]
          }
        })
        tripsMarkers.push({
          edge_id: edgeId,
          marker_type: 'trips_marker',
          lat: tripEndPoint[0],
          lng: tripEndPoint[1],
          icon: {
            iconUrl: require('../../images/marker-end.png'),
            iconSize: [30, 30],
            iconAnchor: [0, 30]
          }
        })
        $scope.allMarkers = $scope.allMarkers.concat(tripsMarkers)
        if ($scope.event_markers.length > 0) {
          selectedTripEvents = $scope.event_markers.filter(marker => {
            const eventTime = moment(marker.edge_event.time)
            const tripStart = moment.unix(trip.start.time)
            const tripEnd = moment.unix(trip.end.time)
            return (
              eventTime.isSameOrAfter(tripStart) && eventTime.isBefore(tripEnd)
            )
          })
          $scope.allMarkers = $scope.allMarkers.concat(selectedTripEvents)
        }

        $scope.paths = [
          {
            getMessageScope: () => $scope,
            message: '',
            weight: $scope.data.whitelabel.whiteLabelMapType ? 0 : 10,
            color: '#165a94',
            fillColor: '#b2abab1c',
            latlngs: positions,
            type: 'polyline',
            compileMessage: true,
            edge_id: edgeId,
            info: {
              rawGpsPoints
            }
          }
        ]
        $timeout(() => {
          $scope.decorations = {
            markers: {
              coordinates: positions,
              patterns: [
                {
                  offset: '1%',
                  repeat: 45,
                  symbol: $scope.data.whitelabel.whiteLabelMapType
                    ? L.Symbol.arrowHead({
                        pixelSize: 14,
                        polygon: false,
                        pathOptions: { stroke: true, color: '#165a94' }
                      })
                    : L.Symbol.arrowHead({
                        pixelSize: 6,
                        polygon: false,
                        pathOptions: { stroke: true, color: '#fff' }
                      })
                }
              ]
            }
          }

          if ($rootScope.isUserMapViewer()) {
            // Force pointer-events: none on route path polyline element
            $timeout(() => {
              const routePolylines = document.querySelectorAll(
                '.leaflet-overlay-pane svg path[stroke="#165a94"]'
              )
              routePolylines.forEach(el => {
                el.style.pointerEvents = 'none'
              })
            }, 300)
          }
        })
        map.fitBounds(positions)
        if ($mdMedia('sm') || $mdMedia('xs')) {
          $scope.closeSideNav('trips-list')
          $scope.closeSideNav('map-multiple-braodcast-videos')
          $scope.closeSideNav('map-media-players')
          $scope.openSideNav('edges-map-sidenav')
        }
      } catch (error) {
        console.log('selectedTripsEmit', error)
      } finally {
        $scope.mapLoadingStatus = false
      }
    })
    $scope.$on('mapHistorySend', function (e, { data }) {
      const edge = data.edge || {}
      $scope.allMarkers = []
      $scope.paths = []
      $scope.decorations = {}
      manageDeviceLastLocation(edge.imei)
    })
    $scope.$on('loadGeofencePathsEmit', function (e, data) {
      $scope.geofencePaths = []
      toggleElement('fenceIcon', 'none')
      toggleElement('mapIcon', 'flex')
      $scope.showGeofencePaths(data.edge)
    })
    $scope.getCameraNameByStreamId = (edge, streamId) =>
      window.getCameraNameByStreamId($filter('translate'), edge, streamId)

    const getEventRecordingsAvailability = async (imei, event) => {
      const RECORDINGS_REQUEST_WINDOW_DURATION = 5 * 60
      const startTime = moment
        .utc(event.time)
        .add(-RECORDINGS_REQUEST_WINDOW_DURATION / 2, 'seconds')
        .toISOString()
      const endTime = moment
        .utc(event.time)
        .add(RECORDINGS_REQUEST_WINDOW_DURATION / 2, 'seconds')
        .toISOString()
      const response = await edgeFactoryV2.getRecordingAvailability(
        imei,
        startTime,
        endTime
      )
      return response.data.data
    }
    $scope.loadEdgeEvents = function (edge, start, end) {
      eventMarkers = []
      $scope.available_edge_event_settings = angular.copy(deviceEventSettings)
      edge = allEdges.find(e => e.imei === edge.imei)
      $scope.edge = edge
      $http({
        method: 'GET',
        url: V2_BASEURL + '/devices/' + edge.imei + '/events',
        params: {
          start: moment(start).format(),
          end: moment(end).format()
        }
      })
        .then(response => {
          const gpsEvents = response.data.data.map(function (g) {
            g.time_string = new Date(g.time).toString()
            g.time_string_formate = new Date(g.time).toString(
              'h:mm:ss tt MMM dd yyyy'
            )
            g.location = g.lat + ',' + g.lon
            g.location_update = false
            return g
          })
          $scope.gpsEvents = gpsEvents
          const mapEdgeEventTypes = $scope.available_edge_event_settings.filter(
            e =>
              ![DEVICES_EVENTS.ACC_ON, DEVICES_EVENTS.ACC_OFF].includes(
                e.v2Name
              )
          )
          $scope.gpsEvents.forEach(function (event, index) {
            $scope.event = event
            event.eventRecordingsOptionState = {
              loading: true,
              availableEventStreamIds: [],
              canPlayEventRecordings: false
            }
            mapEdgeEventTypes.forEach(t => {
              if (event.eventType === t.v2Name) {
                event.edge_setting = t
              }
            })
            $scope.gpsEvents[index].calTime = event.time
            if (event.edge_setting) {
              const speed = UnitSystem.value(
                $scope.gpsEvents[index].speed,
                'km/h',
                '$v$l'
              )
              let markerIcon
              if (event.edge_setting.icon.type === 1) {
                markerIcon = {
                  type: 'div',
                  html: `<div class="icon-container"><md-icon class="material-icons md-default-theme" style="color: #6f6f6f;" role="img">${event.edge_setting.icon.icon}</md-icon></div>`,
                  className: 'map-event-icon-bg',
                  iconSize: [35, 50],
                  iconAnchor: [22, 48]
                }
              } else {
                markerIcon = {
                  className: 'eventMarkers',
                  iconUrl: event.edge_setting.icon.img2,
                  iconSize: [35, 50],
                  iconAnchor: [22, 48],
                  markerColor: 'gray'
                }
              }
              event.auxilaryCameraIds = event.files
                .map(e => e.cameraId)
                .sort((a, b) => a - b)
              eventMarkers.push({
                edge_id: edge.imei,
                edge_event: event,
                marker_type: 'event_marker',
                lat: event.lat,
                lng: event.lon,
                class: 'blue',
                icon: markerIcon,
                message: `<div>
                  <p layout><span class="h3" flex>${edge.name}</span></p>
                  <p layout="column">
                    <span>{{"event" | translate}} : {{gpsEvents[${index}].edge_setting.translate_name | translate}} 
                    <span ng-if="gpsEvents[${index}].edge_setting.id === 6"> Driving at ${speed}</span>
                    <span ng-if="gpsEvents[${index}].edge_setting.id === 8">
                        <small class="word-break">{{gpsEvents[${index}].geofenceName}}</small> / {{(gpsEvents[${index}].geofencePath=="Out Of Fence" ) ? "exit" :"entered" | translate}}
                    </span>
                    </span
                    <span translate="address">Address</span>: {{gpsEvents[${index}].location}}</span>
                    <span>{{"date" | translate}}: {{getFullDate(gpsEvents[${index}].calTime)}}</span>
                    <span>{{"time" | translate}}: {{getFullDateTime(gpsEvents[${index}].calTime)}}</span>
                  </p>
                  <div style="max-height: 150px;overflow-y: auto;"  id="map_content">
                    <div ng-click="addEventsToSidenav(gpsEvents[${index}], edge)" class="p-2 subheading-v2 text-center is-clickable map-popup-button">
                      {{"viewEventMedia" | translate}}
                    </div>
                  </div>
                </div>`,
                getMessageScope: function () {
                  return $scope
                },
                compileMessage: true
              })
            }
          })
          $scope.event_markers = eventMarkers
        })
        .catch(handleServerError)
    }
    const serialNumberLastPositionMap = {}

    const getDeviceMarker = (edge, focus = false) => {
      let positionChanged = false
      let markerRotationAngle = 0
      const serialNumber = edge.serialNumber || edge.imei
      const previousPoint = serialNumberLastPositionMap[serialNumber]

      if (previousPoint) {
        positionChanged =
          edge.lat !== previousPoint.lat || edge.lon !== previousPoint.lon
        if (positionChanged) {
          markerRotationAngle = window.getAngleBetween(previousPoint, {
            lat: edge.lat,
            lon: edge.lon
          })
        }
      }
      serialNumberLastPositionMap[serialNumber] = {
        markerRotationAngle: positionChanged
          ? markerRotationAngle
          : previousPoint
          ? previousPoint.markerRotationAngle
          : markerRotationAngle,
        lat: edge.lat,
        lon: edge.lon
      }

      const index = $scope.edges.findIndex(e => e.imei === edge.imei)

      $scope.edgeSpeed = $scope.edges[index]
        ? Math.round($scope.edges[index].speed * 3.6)
        : 0

      const markerConfig = {
        edge_id: edge.imei,
        marker_type: 'edge_marker',
        lat: edge.lat,
        focus,
        lng: edge.lon,
        icon: {
          iconUrl: positionChanged
            ? require('../../images/arrow-right.png')
            : require('../../images/map.png'),
          iconSize: positionChanged ? [30, 20] : [25, 35],
          iconAnchor: positionChanged ? [10, -10] : null,
          className: 'surf-animated-marker-icon'
        },
        iconAngle: positionChanged ? markerRotationAngle - 90 : 0,
        getMessageScope: () => {
          return $scope
        },
        tooltip: {
          message: `<span>{{edges[${index}].name}}</span>`,
          options: {
            permanent: true,
            direction: 'top',
            className: 'surf-animated-marker-tooltip'
          }
        }
      }

      // Show detailed popup only if the user is not a map viewer
      if (!$rootScope.isUserMapViewer()) {
        markerConfig.message = `<div>
              <p layout>
                <span class="h3" flex>{{edges[${index}].name}}</span>
              </p>
              <p layout="column">
                <span ng-if="edgeSpeed" ><span translate="speed">Speed </span>: {{UnitSystem.value(edgeSpeed, "km/h", "$v$l")}} </span>
                <span><span translate="date">Date</span>: {{getFullDate(edges[${index}].lastSeenOnline)}}</span>
                <span><span translate="time">Time</span>: {{getFullDateTime(edges[${index}].lastSeenOnline)}}</span>
              </p>
              <div ng-if="edges[${index}].status === 'online'"
                   class="cursorCls" style="max-height: 150px;overflow-y: auto;" id="map_content">
                <div layout
                ng-repeat="onlineCameraId in edges[${index}].onlineCameraIds"
                ng-click="broadcastsAdded(edges[${index}].imei, onlineCameraId)"
                >
                  <md-icon class="material-icons map-marker-avatar-icon" md-colors="{background:'primary'}">videocam</md-icon>
                  <div class="md-list-item-text" flex>
                    <p style="margin: 10px 0;font-size: 14px;" >&nbsp;<span>{{getCameraNameByStreamId(edges[${index}], onlineCameraId)}}</span></p>
                  </div>
                </div>
              </div>
            </div>
            `
        markerConfig.compileMessage = true
      }

      return markerConfig
    }
    $scope.getFullDateTime = function (t) {
      const timeZone = new Date(t).toString().substr(25)
      if ($localStorage.timeFormat == 2) {
        return new Date(t).toString('hh:mm:ss tt') + ' ' + timeZone
      } else {
        return new Date(t).toString('HH:mm:ss') + ' ' + timeZone
      }
    }
    $scope.getFullDate = function (t) {
      return (
        $translate(new Date(t).toString('MMM')) +
        ' ' +
        $translate(new Date(t).toString('ddd')) +
        ' ' +
        $translate(new Date(t).toString('dd')) +
        ' ' +
        $translate(new Date(t).toString('yyyy'))
      )
    }
    $scope.getSelectedBroadcastsIncluding = function (number, name, edge_id) {
      const draggedBroadcast = {}
      draggedBroadcast.number = number
      draggedBroadcast.name = name
      draggedBroadcast.edge_id = edge_id
      return [draggedBroadcast]
    }
    $scope.broadcastsAdded = function (imei, streamId) {
      const edge = allEdges.find(e => e.imei === imei)

      const dashcamStream = {
        edgeId: edge.imei,
        serialNumber: edge.imei,
        streamId,
        cameraName: edge.name
      }
      $scope.openSideNav('map-multiple-braodcast-videos')
      $scope.$emit('dashcamStreamsAddedRequest', {
        dashcamStreams: [dashcamStream]
      })
      closeMapMediaPlayers()
      $scope.changeMapCenter(dashcamStream, true)
      if ($mdMedia('gt-sm')) {
        $scope.changeMapview()
      }
    }
    $scope.changeMapview = function () {}
    $scope.changeMapCenter = function (dashcamStream, changeMapCenter) {
      if (changeMapCenter) {
        const currentZoom = angular.copy($scope.mapCenter.zoom)
        const edge = allEdges.find(e => e.imei === dashcamStream.edgeId)
        leafletData.getMap().then(function (map) {
          $timeout(() => {
            map.invalidateSize()
          }, 300)
        })
        $scope.mapCenter = {
          lat: edge.lat,
          lng: edge.lon,
          zoom: currentZoom
        }
      }
    }

    $scope.showAddGeofenceModal = function (geoJSONData, layerData) {
      $mdDialog
        .show({
          locals: {
            dataFromCaller: {
              edge_id: $scope.edge_id,
              geoJSON_data: geoJSONData,
              layerData: layerData
            }
          },
          controller: 'geofenceAddCtrl',
          templateUrl:
            './templates/edge.geofence.add.view.html?t=' + window.webpackHash,
          parent: angular.element(document.body),
          targetEvent: null,
          clickOutsideToClose: true,
          fullscreen: true // Only for -xs, -sm breakpoints.
        })
        .then(
          () => {
            geofenceFactory.list = []
            $scope.$emit('loadGeofenceData', {})
            $scope.showGeofencePaths()
            leafletData.getMap().then(map => map.removeLayer(layerData))
          },
          response => {
            leafletData.getMap().then(map => map.removeLayer(layerData))
            $scope.$emit('clearGeofence', { response })
          }
        )
    }
    $scope.showSelectedGeofencePath = function (g, e) {
      if ($mdMedia('sm') || $mdMedia('xs')) {
        $scope.closeSideNav('geofence-list')
      }
      $scope.geofenceList.forEach(function (f, i) {
        geofenceFactory.list[i].opened = false
      })
      g.opened = true
      $scope.paths = []
      const geofencePath = []
      $scope.geofenceName = ''
      $scope.geofencePaths = []
      $scope.geofenceName = g.name
      const fenceNameTxt = $translate('fenceName')
      geofencePath.push({
        getMessageScope: function () {
          return $scope
        },
        message: `<p style='margin: 10px 0;font-size: 14px;'>${fenceNameTxt}: ${g.name}</p>`,
        weight: 2,
        color: 'red',
        fillColor: '#b23030',
        latlngs: {
          lat: g.lat,
          lng: g.lon,
          draggable: false
        },
        radius: g.radius,
        type: 'circle',
        fence_id: g.id
      })
      $timeout(() => {
        $scope.paths = geofencePath
      }, 200)
      leafletData.getMap().then(function (map) {
        const currentLatLog = geofencePath[0].latlngs
        const currentDiameter = L.circle(
          [currentLatLog.lat, currentLatLog.lng],
          geofencePath[0].radius
        )
        currentDiameter.addTo(map)
        map.fitBounds(currentDiameter.getBounds())
        $timeout(function () {
          map.removeLayer(currentDiameter)
        })
      })
    }
    $scope.showAllFences = function (edge) {
      if ($mdMedia('sm') || $mdMedia('xs')) {
        $scope.closeSideNav('geofence-list')
      }
      $scope.showGeofencePaths(edge)
    }
    $scope.addEventsToSidenav = function (event, edge) {
      $scope.$emit('eventsVideoAdded', {
        event: event,
        edge: edge
      })
      $rootScope.$broadcast('closeAllBroadcasts', {})
      $scope.closeSideNav('map-multiple-braodcast-videos')
      $scope.openSideNav('map-media-players')
      $scope.changeMapview()
    }
    $scope.addEventRecordingPlayerToSidenav = (event, edge) => {
      $scope.$emit('eventsRecordingsPlayerAdded', {
        event: event,
        device: {
          ...edge,
          cameras: [1, 2, ...edge.cameras.map(({ cameraId }) => cameraId)].map(
            cameraId => ({
              cameraId,
              name: $rootScope.getCameraNameByStreamId(edge, cameraId)
            })
          )
        }
      })
      $scope.openSideNav('map-multiple-braodcast-videos')
      $scope.changeMapview()
    }
    $scope.addRecordingsToSidenav = (
      streamId,
      edge,
      nearestLocation,
      recordingStreamQuality
    ) => {
      $scope.$emit('recordingVideoAdded', {
        streamId,
        edge,
        nearestLocation,
        recordingStreamQuality
      })
      $scope.openSideNav('map-multiple-braodcast-videos')
      $scope.changeMapview()
    }

    $scope.map_events = {
      map: {
        enable: [
          'zoomstart',
          'zoomend',
          'drag',
          'popupopen',
          'popupclose',
          'baselayerchange'
        ],
        logic: 'emit'
      }
    }
    const updateUserMapType = mapLayerId => {
      const userSettings = {
        mesaurement: $localStorage.measurementUnits,
        timeFormat: $localStorage.timeFormat,
        mapLayerId
      }
      $http({
        method: 'PUT',
        url: `${USER_BASEURL}/user/settings`,
        data: userSettings
      })
        .then(() => {
          $localStorage.userDetails.userSettings.mapLayerId = mapLayerId
        })
        .catch(handleServerError)
    }
    let openedEdgeMarkerId
    const handleMapEvent = function (event, args) {
      switch (event.name) {
        case 'leafletDirectiveMap.citymap.baselayerchange':
          updateUserMapType(args.leafletEvent.layer.options.layerId)
          break
        case 'leafletDirectiveMap.citymap.popupclose':
          openedEdgeMarkerId = null
          $scope.markerPopupOpen = true
          break
        case 'leafletDirectiveMap.citymap.popupopen':
          const edgeImei = args.leafletEvent.popup._source.options.edge_id
          const edgeEvent = args.leafletEvent.popup._source.options.edge_event
          const markerType = args.leafletEvent.popup._source.options.marker_type

          if (edgeImei && markerType === 'edge_marker') {
            openedEdgeMarkerId = edgeImei
            const edge = allEdges.find(e => e.imei === openedEdgeMarkerId)
            if (edge && !edge.cameras) {
              updateDeviceCameras(edge.imei, false)
            }
            if (edge && edge.status === DEVICE_STATUS.ONLINE) {
              updateActiveCameras(edge.imei)
            }
          }
          $scope.markerPopupOpen = false
          break
        case 'leafletDirectiveMap.citymap.zoomstart':
        case 'leafletDirectiveMap.citymap.zoomend':
          $scope.dragZoomStatus = true
          break
        case 'leafletDirectiveMap.citymap.drag':
          $scope.dragZoomStatus = true
          if (!$scope.disablePopupCloseOnDrag) {
            leafletData.getMap().then(function (map) {
              map.closePopup()
            })
          }
          break
      }
    }
    const toggleElement = (className, display) => {
      const element = document.getElementsByClassName(className)
      if (element.length) {
        element[0].style.display = display
      }
    }
    $scope.map_events.map.enable.forEach(function (eventName) {
      $scope.$on('leafletDirectiveMap.citymap.' + eventName, handleMapEvent)
    })
    $scope.currentPointRecordingStreams = []
    $scope.$on('leafletDirectivePath.citymap.click', (event, args) => {
      const leafletEvent = args.leafletEvent
      if ($rootScope.isUserMapViewer()) {
        return
      }
      if (leafletEvent.target.options.info) {
        const rawGpsPoints = leafletEvent.target.options.info.rawGpsPoints
        const edgeId = leafletEvent.target.options.edge_id
        const nearestLocationDetailsOnPolylineSegments = getNearestLocationDetailsOnPolylineSegments(
          leafletEvent.target._map,
          rawGpsPoints.map(p => new L.LatLng(p.lat, p.lon)),
          leafletEvent.latlng
        )
        const nearestLocationIndex =
          nearestLocationDetailsOnPolylineSegments.index
        const nearestLocation = {
          ...rawGpsPoints[nearestLocationIndex],
          lat: nearestLocationDetailsOnPolylineSegments.location.lat,
          lon: nearestLocationDetailsOnPolylineSegments.location.lon
        }
        if (!$scope.edge.semanticVersion) {
          updateCurrentDeviceSemanticVersion()
        }
        const edge = allEdges.find(e => e.imei === edgeId)
        $scope.edgeLocationDetails = nearestLocation
        $scope.currentPointRecordingStreams = []
        const message = `
        <h3>${edge.name}</h3>
        ${$translate('speed')}: 
        ${UnitSystem.value(
          Math.round(nearestLocation.speed * 3.6 * 10) / 10,
          'km/h',
          '$v$l'
        )}
        
        ${
          nearestLocation.postedSpeed
            ? '<br>' +
              $translate('postedSpeed') +
              ': ' +
              UnitSystem.value(
                Math.round(nearestLocation.postedSpeed * 3.6 * 10) / 10,
                'km/h',
                '$v$l'
              )
            : ''
        }
        ${
          nearestLocation.postedSpeedHgv
            ? '<br>' +
              $translate('postedSpeedHgv') +
              ': ' +
              UnitSystem.value(
                Math.round(nearestLocation.postedSpeedHgv * 3.6 * 10) / 10,
                'km/h',
                '$v$l'
              )
            : ''
        }
        ${
          nearestLocation.postedSpeedTrailer
            ? '<br>' +
              $translate('postedSpeedTrailer') +
              ': ' +
              UnitSystem.value(
                Math.round(nearestLocation.postedSpeedTrailer * 3.6 * 10) / 10,
                'km/h',
                '$v$l'
              )
            : ''
        }
        <br>
        ${$translate('date')}:
        ${$scope.getFullDate(nearestLocation.time * 1000)}
        <br>
        ${$translate('time')}: 
        ${$scope.getFullDateTime(nearestLocation.time * 1000)}
        <br>
        <div style="max-height: 150px; overflow-y: auto;" id="map_content" ng-if="currentPointRecordingStreams.length" class="ng-scope">
          <div layout="row" class="layout-row cursorCls" ng-repeat="stream in currentPointRecordingStreams">
            <md-icon class="material-icons map-marker-avatar-icon" md-colors="{background:'primary'}" style="background: rgb(244, 67, 54); color: rgb(255, 255, 255); margin: 5px;">videocam</md-icon>
            <div class="md-list-item-text" flex>
              <p style="margin:10px ;font-size:14px;" ng-click="addRecordingsToSidenav(stream.streamId,edge,edgeLocationDetails, selectedRecordingStreamQuality)" role="button" tabindex="0">
                <span class="ng-scope">{{stream.streamName | translate}}</span>
              </p>
            </div>
          </div>
          <div ng-if="edge.canPlaySelectedQualityRecording">
            <md-button class="md-primary map-chip-btn" ng-class="{active: recordingStreamQuality.value === selectedRecordingStreamQuality.value}" ng-repeat="recordingStreamQuality in $root.recordingStreamQualities" ng-click="setRecordingStreamQuality(recordingStreamQuality)" title="{{recordingStreamQuality.description}}">
              {{recordingStreamQuality.shortName}}
            </md-button>
          </div>
        </div>
     `
        const angularPopupElement = angular.element(message)
        const leafpopupFunction = $compile(angularPopupElement)
        const newScope = $scope.$new()
        const el = leafpopupFunction(newScope)
        angular.element('.leaflet-popup-content').empty()
        angular.element('.leaflet-popup-content').append(el)

        const edgeTime = nearestLocation.time
        const start = moment(edgeTime * 1e3).toISOString()
        const end = moment((edgeTime + 120) * 1e3).toISOString()
        const data = {
          last_know_id: 0,
          number_of_records: 0,
          time_range: {
            start,
            end
          }
        }
        edgeFactoryV2
          .getRecordingAvailability(edgeId, start, end)
          .then(response => {
            const availableRecordings = response.data.data.filter(
              ({ cameraId, intervals }) => {
                return intervals.some(interval =>
                  moment(interval.end).isAfter(moment(interval.start))
                )
              }
            )

            $scope.currentPointRecordingStreams = [
              ...new Set(availableRecordings.map(r => r.cameraId))
            ]
              .sort((a, b) => a - b)
              .map(streamId => ({
                streamId,
                streamName: window.getCameraNameByStreamId(
                  $filter('translate'),
                  edge,
                  streamId
                )
              }))
          })
      }
    })
    $scope.$on('$destroy', function () {
      if (locationUpdateStatusInterval) {
        $interval.cancel(locationUpdateStatusInterval)
      }
      leafletData.getMap().then(map => map.off())
    })
    $timeout(function () {
      toggleElement('fenceIcon', 'none')
      toggleElement('mapIcon', 'none')
    })
  }
])
